import React, { useEffect, useState } from 'react';

import { POST_TYPE } from 'constants/global';
import { useGetReactionsSummaryQuery } from 'services/reactionManagement';

import InteractionButtons from './InteractionButtons';
import InteractionCounter from './InteractionCounter';
import { Container, HorizontalBar } from './styles';

interface TopicFooterProps {
  post: any;
  postType: POST_TYPE;
}

const TopicFooter: React.FC<TopicFooterProps> = ({ post, postType }) => {
  const { data: reactionSummary, refetch } = useGetReactionsSummaryQuery(
    post._id,
  );
  const commentsCount = post?.commentsCount || 0;

  return (
    <>
      <InteractionCounter
        reactionSummary={reactionSummary || { totalCount: 0, reactions: [] }}
        commentsCount={commentsCount}
      />
      <Container>
        <HorizontalBar />
        <InteractionButtons
          postType={postType}
          postId={post._id}
          refetchReactions={refetch}
        />
        <HorizontalBar />
      </Container>
    </>
  );
};

export default TopicFooter;
